import { motion } from 'motion/react';
import { Shield, Database, Gavel, Code2, MessageCircle, Award } from 'lucide-react';
import { MarketingLayout } from '../../layouts/MarketingLayout';

const services = [
  {
    icon: Shield,
    title: 'Identity Management',
    desc: 'Biometric WebAuthn-based identity that follows you across every Keskedo app — no more passwords.',
  },
  {
    icon: Database,
    title: 'Secure Data Vaults',
    desc: 'End-to-end encrypted vaults you control. Grant and revoke access at the field level.',
  },
  {
    icon: Gavel,
    title: 'Community Governance Tools',
    desc: 'Voting, proposals, and reputation primitives baked into the platform — not bolted on.',
  },
  {
    icon: Code2,
    title: 'Developer SDKs',
    desc: 'First-class SDKs for iOS, Android, and the web, with typed APIs and full identity integration.',
  },
  {
    icon: MessageCircle,
    title: 'Cross-App Communication',
    desc: 'Apps in the Keskedo ecosystem talk to each other through a unified, permissioned event bus.',
  },
  {
    icon: Award,
    title: 'Reputation Systems',
    desc: 'Portable, cryptographically-verifiable reputation that travels with the user, not the app.',
  },
];

export const Services = () => {
  return (
    <MarketingLayout
      title="Our Core Services"
      subtitle="A comprehensive suite of tools and infrastructure designed to empower users, communities, and developers alike."
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map((s, i) => (
          <motion.div
            key={s.title}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.05 }}
            className="p-8 rounded-2xl border border-slate-100 bg-slate-50/50 hover:bg-white hover:shadow-xl hover:border-indigo-100 transition-all group"
          >
            <div className="h-12 w-12 rounded-xl bg-indigo-600 text-white flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
              <s.icon size={22} />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3">{s.title}</h3>
            <p className="text-slate-600 text-sm leading-relaxed">{s.desc}</p>
          </motion.div>
        ))}
      </div>
    </MarketingLayout>
  );
};
